import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=10f67842&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"
import style0 from "./Write.vue?vue&type=style&index=0&id=10f67842&prod&scoped=true&lang=scss"
import style1 from "./Write.vue?vue&type=style&index=1&id=10f67842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f67842",
  null
  
)

export default component.exports